let isMobile = {
    devices: [
        'Silk',
        'Playbook',
        'Nexus 7',
        'Nexus 10',
        'Tablet',
        'Mobile',
        'iPhone',
        'iPod',
        'iPad',
    ],

    inMobileDeviceList() {
        return isMobile.devices.some(
            device => navigator.appVersion.indexOf(device) !== -1
        );
    },

    // Values are taken from the max width of iPhone 8+ (414px) and max height of iPhone X (812px)
    hasMobileDeviceSize() {
        return (
            document.documentElement.clientWidth < 415 &&
            document.documentElement.clientHeight < 813
        );
    },
};
export { isMobile };
